import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=58345d68&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
import style0 from "../../style/message-box.scss?vue&type=style&index=0&id=58345d68&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58345d68",
  null
  
)

export default component.exports